import { render, staticRenderFns } from "./TestMessageComp.vue?vue&type=template&id=259ffcde&scoped=true&"
import script from "./TestMessageComp.vue?vue&type=script&lang=tsx&"
export * from "./TestMessageComp.vue?vue&type=script&lang=tsx&"
import style0 from "./TestMessageComp.vue?vue&type=style&index=0&id=259ffcde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ffcde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259ffcde')) {
      api.createRecord('259ffcde', component.options)
    } else {
      api.reload('259ffcde', component.options)
    }
    module.hot.accept("./TestMessageComp.vue?vue&type=template&id=259ffcde&scoped=true&", function () {
      api.rerender('259ffcde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingTestPages/TestMessageComp.vue"
export default component.exports